import { createAppSlice } from 'app/createAppSlice'

const initialState = {
  tag: {
    size: 10,
    page: 0,
    search: undefined,
    objectTypeId: undefined,
    eventTypeId: undefined,
    categoryId: undefined,
  },
}

export const dashboardTraceabilitySlice = createAppSlice({
  name: 'dashboardTraceability',
  initialState,
  reducers: (create) => ({
    setFetchOption: create.reducer((state, { payload }) => {
      state.tag = { ...state.tag, ...payload }
    }),
  }),
  extraReducers: (builder) => {},
})

export const { setFetchOption, toggleSidebarEvent } =
  dashboardTraceabilitySlice.actions

export default dashboardTraceabilitySlice.reducer
